/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_RemovedInputs */

const en_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document removed`)
};

const es_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento eliminado`)
};

const fr_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document retiré`)
};

const de_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument entfernt`)
};

const ja_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメントが削除されました`)
};

const zh_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档已移除`)
};

const ar_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت إزالة المستند`)
};

const id_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen dihapus`)
};

const it_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento rimosso`)
};

const ru_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документ удален`)
};

const pt_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento removido`)
};

const ko_document_removed = /** @type {(inputs: Document_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서가 제거되었습니다`)
};

/**
* | output |
* | --- |
* | "Document removed" |
*
* @param {Document_RemovedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_removed = /** @type {((inputs?: Document_RemovedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_RemovedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_removed(inputs)
	if (locale === "es") return es_document_removed(inputs)
	if (locale === "fr") return fr_document_removed(inputs)
	if (locale === "de") return de_document_removed(inputs)
	if (locale === "ja") return ja_document_removed(inputs)
	if (locale === "zh") return zh_document_removed(inputs)
	if (locale === "ar") return ar_document_removed(inputs)
	if (locale === "id") return id_document_removed(inputs)
	if (locale === "it") return it_document_removed(inputs)
	if (locale === "ru") return ru_document_removed(inputs)
	if (locale === "pt") return pt_document_removed(inputs)
	return ko_document_removed(inputs)
});